export default () => '/unverified-bookings';
